import styles from "./perfil-modal.module.css";

interface IProps {
  title: string;
  text: string;
  image: any;
  lattes?: string;
  linkedin?: string;
}

const PerfilModal = ({ title, text, image, lattes, linkedin }: IProps) => {
  const onClickLattes = (link: string) => {
    return window.open(link, "_blank");
  };

  return (
    <div className={styles.shape}>
      <div className={styles.infos}>
        <div className={styles.div_texts}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.paragraph}>{text}</p>
        </div>
        <div className={styles.btns_div}>
          {lattes && (
            <button
              className={styles.btn_perfil}
              onClick={() => onClickLattes(lattes)}
            >
              LATTES
            </button>
          )}
          {linkedin && (
            <button
              className={styles.btn_perfil}
              onClick={() => onClickLattes(linkedin)}
            >
              LINKEDIN
            </button>
          )}
        </div>
      </div>
      <div className={styles.image_div}>
        <img className={styles.image_perfil} src={image} alt="Imagem perfil." />
      </div>
      <div className={styles.infosMobile}>
        <div className={styles.div_texts}>
          <h2 className={styles.title}>{title}</h2>
        </div>
        <div className={styles.btns_div}>
          {lattes && (
            <button
              className={styles.btn_perfil}
              onClick={() => onClickLattes(lattes)}
            >
              LATTES
            </button>
          )}
          {linkedin && (
            <button
              className={styles.btn_perfil}
              onClick={() => onClickLattes(linkedin)}
            >
              LINKEDIN
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PerfilModal;
